import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import Icon from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { selector as defaultLandingPageSelector } from '@store/defaultLandingPage';
import isDefaultLandingPage from '@utils/isDefaultLandingPage';
import HomeSvg from '@icons/home.svg';
import PromptSvg from '@icons/prompt.svg';
import NewSvg from '@icons/new-icon.svg';
import { FeatureToggle } from '@components/common';
import globalStyles from '../index.less';
import AccessWrapper from '../AccessWrapper';
import { TAB_TITLE_PROMPT, TAB_TITLE_AI_ALERT, TAB_TITLE_AI_ROADMAP } from '@src/utils/constants';

const { baseUrl } = window.conviva;

const FeatureTab = ({ tabKey, isGA, feature, tabTitle, route, exact, isNewFeature = false }) => {
  const to = `${baseUrl}${route}`;
  const defaultLandingPage = useSelector(defaultLandingPageSelector);
  const isDefaultPage = isDefaultLandingPage(defaultLandingPage.url, to);
  const tabID = feature != null ? `default-icon-${feature}` : 'default-icon-trends';
  const isSharedTab = () => {
    const checkString = ['sharing', 'ba-drilldown', 'na-drilldown'];
    return checkString.some((string) => window.location.pathname.includes(string));
  };
  const isAIRelated =
    tabTitle === TAB_TITLE_PROMPT ||
    tabTitle === TAB_TITLE_AI_ALERT ||
    tabTitle === TAB_TITLE_AI_ROADMAP;

  const getIcon = () => {
    const Icons = [] as React.ReactNode[];
    if (isDefaultPage) {
      Icons.push(
        <Icon
          key={'home-icon-1'}
          className={classnames(globalStyles.homeIcon, {
            [globalStyles.active]: window.location.pathname.includes(route) && !isSharedTab(),
          })}
          component={HomeSvg}
          style={{ fontSize: '20px', verticalAlign: 'unset' }}
          id={tabID}
          data-test-id="home-icon"
        />,
      );
    }
    if (isNewFeature) {
      Icons.push(
        <Icon
          key={'home-icon-2'}
          className={classnames(globalStyles.homeIcon, {
            [globalStyles.active]: window.location.pathname.includes(route),
          })}
          component={NewSvg}
          style={{ fontSize: '28px', paddingRight: '2px' }}
          data-test-id="new-icon"
        />,
      );
    }
    if (isAIRelated) {
      Icons.push(
        <Icon
          key={'prompt-icon'}
          className={classnames(globalStyles.promptIcon, {
            [globalStyles.active]: window.location.pathname.includes(route),
          })}
          component={PromptSvg}
          style={{ fontSize: '16px', paddingRight: '2px' }}
          data-test-id="prompt-icon"
        />,
      );
    }
    return Icons;
  };
  const getTab = () => (
    <AccessWrapper feature={feature}>
      <NavLink
        id={`tab-${tabKey}`}
        key={tabKey}
        to={to}
        className={classnames(globalStyles.tab)}
        activeClassName={globalStyles.active}
        style={isNewFeature ? { paddingLeft: 0 } : undefined}
        exact={exact}
      >
        {getIcon()}
        {tabTitle}
      </NavLink>
    </AccessWrapper>
  );

  if (isGA) {
    return getTab();
  }

  return <FeatureToggle feature={feature}>{getTab()}</FeatureToggle>;
};

export default FeatureTab;
